export enum ERecallReputModes {
  RECALL = 'RECALL',
  REPUT = 'REPUT',
}
